export default function (value) {
    // [TODO-L][FID-114] Deixar internacional
    // return i18n.n('currency', value)
    return 'R$ ' + (value || 0)
}